import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import uuid from 'uuid/v4';
import BarChart from '../common/Charts/BarChart';
import GenericButton from '../common/GenericButton';
import TimeSpentLegends from './TimeSpentLegends';
import {
  processTimeSpentIcons,
  TIME_SPENT_ICONS,
  calculateAsterisk,
  checkAsterickFormate,
  TIME_SPENT_INDEX,
  isMRISpecificStudy,
  calculateMRIAsterisk,
} from '../../util/QuickReportsUtils';
import { numberWithCommas } from '../../util/CommonUtils';
import { MODULE_TIME_SPENT } from '../../constants';
import QuickReportFootNote from './QuickReportFootNotes';

export default class TimeSpent extends PureComponent {
  constructor(props) {
    super(props);
    this.finalcombos = [];
    this.state = {
      selectedRadioButton: 'Percent',
      legendRemovFlag: false,
      showDataLabel: false,
      selectedDropdown: '1 -4 Hours',
      showSingleAsterisk: false,
      showDoubleAsterisk: false,
      rename: {},
      renameValuekey: {},
      hideIcon: {},
      remove: {},
      combos: [],
      removeIndex: [],
      // finalcombos: [[1,2]],
      drilldown: false,
      drilldownColor: [],
      showLabels: true,
      displayAverageTimeSpent: false,
      chartStacking: 'normal',
      avgTimeSpentFlag: true,
      clickedLegend: {},
      combinedLegend: {},
      LegendVisibility: false,
      ReportDropdown: [
        {
          key: '40+ Hours',
          value: '40+ Hours',
          color: '#247BA0',
        },
        {
          key: '20-39 Hours',
          value: '20-39 Hours',
          color: '#F25F5C',
        },
        {
          key: '5-19 Hours',
          value: '5-19 Hours',
          color: '#FFE066',
        },
        {
          key: '1 -4 Hours',
          value: '1 -4 Hours',
          color: '#008490',
        },
        {
          key: 'Under 1 Hour',
          value: 'Under 1 Hour',
          color: '#94D3DC',
        },
      ],
    };
  }

  componentDidMount() {
    this.props.handletitle('Time Spent Composition: Last 7 Days');
    this.props.handleExportParams(
      this.state.selectedRadioButton,
      undefined,
      this.state.combos,
      this.state.removeIndex,
    );
    this.props.trackerFn({ subModule: MODULE_TIME_SPENT });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.data !== this.props.data) {
      this.setState({
        showSingleAsterisk: false,
        showDoubleAsterisk: false,
        ReportDropdown: [
          {
            key: '40+ Hours',
            value: '40+ Hours',
            color: '#247BA0',
          },
          {
            key: '20-39 Hours',
            value: '20-39 Hours',
            color: '#F25F5C',
          },
          {
            key: '5-19 Hours',
            value: '5-19 Hours',
            color: '#FFE066',
          },
          {
            key: '1 -4 Hours',
            value: '1 -4 Hours',
            color: '#008490',
          },
          {
            key: 'Under 1 Hour',
            value: 'Under 1 Hour',
            color: '#94D3DC',
          },
        ],
        legendRemovFlag: false,
      });
    }
    if (nextProps.data !== this.props.data) {
      this.setState({
        rename: {},
        renameValuekey: {},
        hideIcon: {},
        remove: {},
        combos: [],
        removeIndex: [],
        drilldown: false,
        drilldownColor: ['#247BA0'],
        showLabels: true,
      });
    }
  }

  backToTimeSpent = () => {
    this.props.handletitle('Time Spent Composition: Last 7 Days');
    this.setState({
      drilldown: false,
      displayAverageTimeSpent: false,
    });
  };

  drilldown = label => {
    let drilldownColor = [];
    this.state.ReportDropdown.forEach(item => {
      if (item.key === label) {
        drilldownColor = item.color; // chartColor[index];
      }
    });
    this.setState({
      drilldown: label,
      drilldownColor,
      legendRemovFlag: true,
    });
    this.props.handletitle(`Time Spent ${label}: Last 7 Days`);
  };

  handleRadioButtonChange = e => {
    this.setState({ selectedRadioButton: e.currentTarget.value }, () => {
      this.props.handleExportParams(
        this.state.selectedRadioButton,
        undefined,
        this.state.combos,
        this.state.removeIndex,
      );
    });
  };
  handleCheckBox = () => {
    this.setState({ showLabels: !this.state.showLabels });
  };
  combineWithLegend = value => {
    this.setState({
      combinedLegend: {
        ...this.state.combinedLegend,
        [this.state.clickedLegend.name]: value,
      },
      ReportDropdown: this.state.ReportDropdown.filter(
        item => item.value !== value,
      ),
    });
  };

  checkAvrgCon = () => {
    if (this.state.legendRemovFlag) {
      return false;
    }
    return true;
  };

  checkAverageTimeSpent = (Data, icon) => {
    let outPut = '';
    Data.forEach(element => {
      if (element.label === icon) {
        outPut = element.value.hours;
        return false;
      }
      return true;
    });
    return outPut;
  };
  processData = () => {
    const outPut = this.state.ReportDropdown.filter(({ key }) => {
      this.state.drilldownColor = [];
      if (this.state.drilldown) {
        return key === this.state.drilldown;
      }
      return true;
    }).map((item, index) => {
      this.state.drilldownColor.push(item.color);
      if (this.state.combinedLegend[item.value]) {
        const combinedLegend = this.props.data[
          this.state.combinedLegend[item.value]
        ][index];
        return {
          name: `${item.value} & ${this.state.combinedLegend[item.value]}`,
          data: this.props.data[item.key]
            .map(({ label, value }) => {
              if (this.state.rename[label]) {
                return {
                  label: this.state.rename[label],
                  value,
                };
              }
              return { label, value };
            })
            .filter(({ label }) => !this.state.remove[label])
            .map(({ label, value }, count) => {
              let asterisk;
              if (isMRISpecificStudy(this.props.study)) {
                asterisk = calculateMRIAsterisk(
                  value.sample + combinedLegend.value.sample, this.props.study.wnt);
              } else {
                asterisk = calculateAsterisk(
                  value.sample + combinedLegend.value.sample,
                );
              }
              if (asterisk === '*' && !this.state.showSingleAsterisk) {
                this.setState({ showSingleAsterisk: true });
              } else if (asterisk === '**' && !this.state.showDoubleAsterisk) {
                this.setState({ showDoubleAsterisk: true });
              }
              return {
                y:
                  this.state.selectedRadioButton === 'Percent'
                    ? Number(value.pct.replace(/%/g, '')) +
                      Number(combinedLegend.value.pct.replace(/%/g, ''))
                    : Number(value.index) + Number(combinedLegend.value.index),
                dataLabels: {
                  enabled: this.state.showLabels,
                  format:
                    asterisk +
                    (this.state.selectedRadioButton === 'Percent'
                      ? value.pct
                      : value.index),
                },
                name: `${label} : ${item.value} & ${
                  this.state.combinedLegend[item.value]
                }`,
                count,
                value: {
                  index:
                    Number(value.index) + Number(combinedLegend.value.index),
                  sample: numberWithCommas(
                    value.sample + combinedLegend.value.sample,
                  ),
                  weighted: numberWithCommas(
                    value.weighted + combinedLegend.value.weighted,
                  ),
                  pct: Math.round(
                    Number(value.pct.replace(/%/g, '')) +
                      Number(combinedLegend.value.pct.replace(/%/g, '')),
                  ),
                  asterisk,
                },
                color: item.color,
              };
            }),
        };
      }
      return {
        name: item.value,
        data: this.props.data[item.key]
          .map(({ label, value }) => {
            if (this.state.rename[label]) {
              return {
                label: this.state.rename[label],
                value,
              };
            }
            return { label, value };
          })
          .filter(({ label }) => !this.state.remove[label])
          .map(({ label, value }, count) => {
            let asterisk;
            if (isMRISpecificStudy(this.props.study)) {
              asterisk = calculateMRIAsterisk(value.sample, this.props.study.wnt);
            } else {
              asterisk = calculateAsterisk(value.sample);
            }
            if (asterisk === '*' && !this.state.showSingleAsterisk) {
              this.setState({ showSingleAsterisk: true });
            } else if (asterisk === '**' && !this.state.showDoubleAsterisk) {
              this.setState({ showDoubleAsterisk: true });
            }
            return {
              y:
                this.state.selectedRadioButton === 'Percent'
                  ? Number(value.pct.replace(/%/g, ''))
                  : value.index,
              dataLabels: {
                enabled: this.state.showLabels,
                format:
                  asterisk +
                  (this.state.selectedRadioButton === 'Percent'
                    ? value.pct
                    : value.index),
              },
              name: `${label} : ${item.value}`,
              count,
              value: {
                index: value.index,
                sample: numberWithCommas(value.sample),
                weighted: numberWithCommas(value.weighted),
                pct: Math.round(Number(value.pct.replace(/%/g, ''))),
                asterisk,
              },
              color: item.color,
            };
          }),
      };
    });
    return outPut;
  };
  processLabels = () => {
    const finalProcess = this.props.data['1 -4 Hours']
      .map(({ label, value }) => {
        const avg = this.checkAverageTimeSpent(
          this.props.data['Average Time'],
          label,
        );
        if (label.includes('&')) {
          return {
            label,
            value,
            avgTimeSpent: avg,
          };
        }

        if (this.state.rename[label]) {
          return {
            label: this.state.rename[label],
            value,
            avgTimeSpent: avg,
          };
        }
        return { label, value, avg };
      })
      .filter(({ label }) => !this.state.remove[label])
      .map(({ label }) => label);

    if (finalProcess.length === 11) {
      this.state.finalcombos = [];
    }
    return finalProcess;
  };
  updateAsteriskStatus = asterisk => {
    if (asterisk === '*' && !this.state.showSingleAsterisk) {
      this.setState({ showSingleAsterisk: true });
    } else if (asterisk === '**' && !this.state.showDoubleAsterisk) {
      this.setState({ showDoubleAsterisk: true });
    }
  };

  removeBar = key => {
    this.setState(
      {
        remove: { ...this.state.remove, [key]: true },
        avgTimeSpentFlag: false,
        removeIndex: [...this.state.removeIndex, TIME_SPENT_INDEX[key]],
      },
      () =>
        this.props.handleExportParams(
          this.state.selectedRadioButton,
          undefined,
          this.state.combos,
          this.state.removeIndex,
        ),
    );
  };

  combineWith = (sourceKey, sourceLabel, combineWithLabel) => {
    const source = this.props.data[sourceKey]
      .map(({ label, value }) => {
        const avg = this.checkAverageTimeSpent(
          this.props.data['Average Time'],
          label,
        );
        if (this.state.rename[label]) {
          return {
            label: this.state.rename[label],
            value,
            avgTimeSpent: avg,
          };
        }
        return { label, value, avg };
      })
      .filter(({ label }) => label === sourceLabel);
    const destination = this.props.data[sourceKey]
      .map(({ label, value }) => {
        if (this.state.rename[label]) {
          return {
            label: this.state.rename[label],
            value,
          };
        }
        return { label, value };
      })
      .filter(({ label }) => label === combineWithLabel);
    const sourceIndex =
      source[0].value.rowIndex || source[0].value.comboIndexes || 0;
    const destinationIndex =
      destination[0].value.rowIndex || destination[0].value.comboIndexes || 0;
    let combos = [];
    if (Array.isArray(sourceIndex) && Array.isArray(destinationIndex)) {
      combos = this.state.combos.filter(
        combo =>
          !(
            JSON.stringify(sourceIndex) === JSON.stringify(combo) ||
            JSON.stringify(destinationIndex) === JSON.stringify(combo)
          ),
      );
      combos.push([...sourceIndex, ...destinationIndex]);
    } else if (Array.isArray(sourceIndex)) {
      combos = this.state.combos.filter(
        combo => !(JSON.stringify(sourceIndex) === JSON.stringify(combo)),
      );
      combos.push([...sourceIndex, destinationIndex]);
    } else if (Array.isArray(destinationIndex)) {
      combos = this.state.combos.filter(
        combo => !(JSON.stringify(destinationIndex) === JSON.stringify(combo)),
      );
      combos.push([sourceIndex, ...destinationIndex]);
    } else {
      combos = this.state.combos;
      combos.push([sourceIndex, destinationIndex]);
    }
    this.setState({ combos }, () => {
      this.props.handleExportParams(
        this.state.selectedRadioButton,
        undefined,
        this.state.combos,
        this.state.removeIndex,
      );
    });
    if (combos.length > 0) {
      this.finalcombos.push(combos[0]);
    }
    this.props.runReport(null, this.finalcombos);
  };
  hideIcon = key => {
    this.setState({
      hideIcon: { ...this.state.hideIcon, [key]: !this.state.hideIcon[key] },
    });
  };

  toggleAverageTimeSpent = () => {
    this.props.handletitle('Average Time Spent: Last 7 Days');
    this.setState({
      displayAverageTimeSpent: !this.state.displayAverageTimeSpent,
    });
  };

  toggleLegend = () => {
    this.setState({
      LegendVisibility: !this.state.LegendVisibility,
    });
  };

  removeLegend = () => {
    this.state.drilldownColor.slice(this.state.clickedLegend.index, 1);
    const legend = this.state.ReportDropdown.filter(
      (item, index) => index !== this.state.clickedLegend.index,
    );
    this.setState({
      ReportDropdown: legend,
      legendRemovFlag: true,
    });
  };

  renameLegend = name => {
    this.setState({
      ReportDropdown: this.state.ReportDropdown.map((item, index) =>
        index === this.state.clickedLegend.index
          ? {
            key: item.key,
            value: name,
            color: item.color,
          }
          : item,
      ),
    });
  };

  setAverageTimeSpentState = () => {
    this.setState({
      displayAverageTimeSpent: true,
      drilldown: true,
    });
  }

  renameLabel = (key, value) => {
    this.setState({
      rename: { ...this.state.rename, [key]: value },
      renameValuekey: { ...this.state.rename, [value]: key },
    });
  };

  renderAverageTimeSpent = () => {
    this.props.handletitle('Average Time Spent: Last 7 Days');
    const outData = this.props.data['Average Time']
      .map(({ label, value }) => {
        if (this.state.rename[label]) {
          return {
            label: this.state.rename[label],
            value,
          };
        }
        return { label, value };
      })
      .filter(({ label }) => !this.state.remove[label])
      .map(({ label, value }) => (
        <div key={uuid()} className="large-2 text-center display-inline time-spent-img">
          {TIME_SPENT_ICONS[label] ? (
            <img src={TIME_SPENT_ICONS[label]} alt="label" />
          ) : (
            label
          )}
          <div className="font-16">{label}</div>
          <div className="font-24">{value.hours}</div>
        </div>
      ));
    return outData;
  };

  render() {
    const { dropdownWindow } = this.props;
    const that = this;
    return (
      <div className="quick-report-graph-wrapper">
        <div className="large-12 margin-top-10 margin-bottom-10">
          <div className="row column">
            {this.state.drilldown ? (
              <GenericButton
                name="Back to Time Spent Report"
                btnStyle="button back-to-dashboard back-to-time-spent float-left"
                onBtnClick={this.backToTimeSpent}
              />
            ) : null}
          </div>
          {this.state.displayAverageTimeSpent ? (
            <div className="large-12">{this.renderAverageTimeSpent()}</div>
          ) : (
            <div>
              <div className="quick-report-radio display-inline padding-5">
                <p>
                  <input
                    type="radio"
                    id="percentType"
                    name="ChartType"
                    value="Percent"
                    checked={this.state.selectedRadioButton === 'Percent'}
                    onChange={this.handleRadioButtonChange}
                  />
                  <label htmlFor="percentType">
                    <span>Percent</span>
                  </label>
                </p>
                <p>
                  <input
                    type="radio"
                    id="indexType"
                    name="ChartType"
                    value="Index"
                    checked={this.state.selectedRadioButton === 'Index'}
                    onChange={this.handleRadioButtonChange}
                  />
                  <label htmlFor="indexType">
                    <span>Index</span>
                  </label>
                </p>
              </div>
              <div className="quick-report-radio display-inline padding-5">
                <p className="quick-report-checkbox">
                  <input
                    type="checkbox"
                    id="showLabels"
                    name="showValues"
                    value={this.state.showLabels}
                    checked={this.state.showLabels}
                    onChange={this.handleCheckBox}
                  />
                  <label htmlFor="showLabels">
                    <span>Show Values on Chart</span>
                  </label>
                </p>
              </div>
              <div className="column large-12">
                <BarChart
                  data={{
                    rawData: this.processData(),
                    y:
                      this.state.selectedRadioButton === 'Percent'
                        ? 'pct'
                        : 'index',
                    tooltip: ['Sample', 'Weighted', 'Percent', 'Indx'],
                  }}
                  chartColor={
                    this.state.drilldown
                      ? [this.state.drilldownColor]
                      : this.state.drilldownColor
                  }
                  legend={{
                    enabled: true,
                    align: 'right',
                    verticalAlign: 'top',
                    layout: 'vertical',
                    x: 0,
                    y: 0,
                    lineHeight: 32,
                    itemStyle: {
                      color: 'RGB(48, 67, 93)',
                      fontSize: '12px',
                      fontWeight: 'normal',
                    },
                  }}
                  showLegend
                  stackedChart
                  stackDataLabels={this.state.showLabels}
                  dataLabelFormat={
                    this.state.selectedRadioButton === 'Percent'
                      ? checkAsterickFormate(
                          '{y}%',
                          this.state.showDoubleAsterisk,
                          this.state.showSingleAsterisk,
                        )
                      : checkAsterickFormate(
                          '{y}',
                          this.state.showDoubleAsterisk,
                          this.state.showSingleAsterisk,
                        )
                  }
                  tickPlacement={'on'}
                  dataLabels={this.state.showDataLabel}
                  xLabelPadding={30}
                  xAxisLabelDistance={0}
                  yAxisLabelDistance={25}
                  chartType={'column'}
                  yLabel={
                    this.state.selectedRadioButton === 'Percent'
                      ? '{value} %'
                      : '{value}'
                  }
                  chartStacking={this.state.chartStacking}
                  seriesStacking={this.state.chartStacking}
                  categories={this.processLabels()}
                  xAxisClick={this.setAverageTimeSpentState}
                  legendItemClick={event => {
                    that.setState({
                      clickedLegend: {
                        name: this.name,
                        index: this.index,
                        offsetX: event.browserEvent.offsetX,
                        offsetY: event.browserEvent.offsetY,
                      },
                      LegendVisibility: true,
                    });
                    return false;
                  }}
                  clickEvent={event => {
                    dropdownWindow
                      .current
                      .setCoordinates(
                        event,
                        event.target.point,
                        that.props.data,
                        that.state.ReportDropdown,
                        that.processLabels(),
                        that.removeBar,
                        that.hideIcon,
                        that.combineWith,
                        that.drilldown,
                        that.renameLabel,
                      );
                  }}
                  labelFormatter={
                    this.checkAvrgCon()
                      ? processTimeSpentIcons(
                          TIME_SPENT_ICONS,
                          this.props.data['Average Time'],
                          this.state.remove,
                          this.state.hideIcon,
                          this.state.rename,
                          that.processLabels(),
                        )
                      : ''
                  }
                />
              </div>
            </div>
          )}
        </div>
        <TimeSpentLegends
          title={this.state.clickedLegend.name}
          offsetX={this.state.clickedLegend.offsetX}
          offsetY={this.state.clickedLegend.offsetY}
          visibility={this.state.LegendVisibility}
          toggleLegend={this.toggleLegend}
          removeLegend={this.removeLegend}
          renameLegend={this.renameLegend}
          combineWith={this.combineWithLegend}
          labels={this.state.ReportDropdown}
        />
        <QuickReportFootNote
          studyInfo={this.props.study}
          className="padding-astrick font-12"
          showSingleAsterisk={this.state.showSingleAsterisk}
          showDoubleAsterisk={this.state.showDoubleAsterisk}
        />
      </div>
    );
  }
}

TimeSpent.propTypes = {
  data: PropTypes.shape({
    '1 -4 Hours': PropTypes.arrayOf(PropTypes.shape({})),
    'Average Time': PropTypes.arrayOf(PropTypes.shape({})),
  }),
  handletitle: PropTypes.func,
  handleExportParams: PropTypes.func,
  runReport: PropTypes.func,
  dropdownWindow: PropTypes.shape({}),
  trackerFn: PropTypes.func,
  study: PropTypes.shape({
    wnt: PropTypes.number,
  }),

};
